import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function LineShareIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="m21.707 11.293-8-8A.9998.9998 0 0 0 12 4v3.5449A11.0153 11.0153 0 0 0 2 18.5V20a.9996.9996 0 0 0 .6715.9445.9999.9999 0 0 0 1.1127-.3239 11.4564 11.4564 0 0 1 7.8867-4.0493c.0498-.0064.1748-.0161.3291-.0259V20a.9997.9997 0 0 0 1.195.9807 1.0002 1.0002 0 0 0 .512-.2737l8-8a1.0008 1.0008 0 0 0 .2929-.707.9992.9992 0 0 0-.2929-.707ZM14 17.5859V15.5a.9998.9998 0 0 0-1-1c-.2549 0-1.2959.0493-1.5615.085a14.0048 14.0048 0 0 0-7.3867 2.9482A9.013 9.013 0 0 1 13 9.5a.9997.9997 0 0 0 1-1V6.414L19.5859 12 14 17.5859Z"/>
  </SvgIcon>
}

export default LineShareIcon
